'use strict';
import {module} from '../app';

module.directive("disableAnimation", function ($animate) {
  return function ($scope, $element) {
    $animate.enabled(false, $element);
  };
});



// WEBPACK FOOTER //
// ./src/scripts/directives/disableAnimation.js